function getDayOfYear(date) {
    var start = new Date(date.getFullYear(), 0, 0)
    var diff = date - start
    var oneDay = 1000 * 60 * 60 * 24
   
    return(Math.floor(diff / oneDay))
}

export default getDayOfYear